// extracted by mini-css-extract-plugin
export default {"cards":"landing_cards__TyZjR"};